import { Component, ElementRef, HostListener, Inject, OnInit, signal, ViewChild, WritableSignal, Optional } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { OverlayPanel } from 'primeng/overlaypanel';
import { compareObjects } from '@helpers/compareObjects';
import { getErrorMessage } from '@helpers/getErrorMessage';
import { estadoFormulario, LimitKindMap, techConfModel, valueToInform, valueToInformMap } from '@modelos/enum/enums';
import { ConfigService } from '@servicios/config.service';
import { forkJoin, map, Observable, startWith, Subject, Subscription, take, tap } from 'rxjs';
import { dialogData } from '@interfaces/dialog-data.interfase';
import { AssayAnalite, AssayAnaliteInput, GetAnalite_analite, GetAssayAnalite_assayAnalite, GetAssayAnalite_assayAnalite_analite, GetAssayAnalite_assayAnalite_limits, GetAssay_assay, GetAssay_assay_analites, GetAssays_assays, GetTechnicalConfigQuery, GetTechnicalConfigQuery_techConfigs, LimitKind, TechConfigModels } from '@interfaces/operation-result-types';
import { ConfiguracionesTecnicasService } from '@servicios/configuracionesTecnicas.service';
import { NotificacionesService } from '@servicios/notificaciones.service';
import { AssayAnaliteService } from '@servicios/assay/assayAnalite.service';
import { AnaliteService } from '@servicios/analite/analite.service';
import { AssayService } from '@servicios/assay/assay.service';
import { valueTakenValidatorGQL } from '@validators/valueTakenValidator_GQL';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { getRowStyle, numberMustBeGreaterThan } from 'app/_sharedFuctions/shared-functions';
import { assayAnaliteInput } from '@modelos/analite/assayAnalite';
import { ApolloQueryResult } from '@apollo/client';

import { AssayAnaliteEcuationFragmentsComponent } from '../assay-analite-ecuation-fragments/assay-analite-ecuation-fragments.component';
import * as _ from 'lodash'
import { validationBio } from '../../../../_sharedFuctions/shared-functions';
import { modalConfig } from 'app/_pipes/modalConfig';
import { FormTechConfig } from '@featuresModules/techConfigModule/generals/form-tech-config/form-tech-config.component';
import { TableDinamicComponent } from '@servicios/dinamic-components/table-dinamic/table-dinamic/table-dinamic.component';
import { TableDinamicService } from '@servicios/dinamic-components/table-dinamic/table-dinamic.service';
import { LoadOptionsService } from '@servicios/load_options/load_options.service';
import { _themeMaterial, singleRow } from '@agGridCellRender/agGrid.configs';
import { MatDialog } from '@angular/material/dialog';
import { FormAdminConfigComponent } from '@featuresModules/adminConfigModule/form-admin-config/form-admin-config.component';
import { AdminConfigService } from '@servicios/adminConfig.service';
import { IAppSettingsFrontendFormControlConfig } from '@modelos/_appSettings/IAppSettings';

@Component({
  selector: 'app-form-assay-analites',
  templateUrl: './form-assay-analites.component.html',
  styleUrls: ['./form-assay-analites.component.css'],
  providers: [DialogService],
  standalone: false
})
export class FormAssayAnalitesComponent implements OnInit {

  public data: dialogData;

  constructor(
    private fb: UntypedFormBuilder,
    private config: ConfigService,
    private as: AssayService,
    private aas: AssayAnaliteService,
    public ref: DynamicDialogRef,
    public configDialog: DynamicDialogConfig,
    private cts: ConfiguracionesTecnicasService,
    private ns: NotificacionesService,
    public dialogService: DialogService,
    private ass: AnaliteService,
    private configService: ConfigService,
    private pipeNameComponent: modalConfig,
    private TDS: TableDinamicService,
    public opts: LoadOptionsService,
    private dialog : MatDialog,
    private acs: AdminConfigService
  ) {
    if (this.configDialog?.data) {
      this.data = this.configDialog.data;
    }
  }

  analiteTypes = [
    {
      title: 'Cualitativo',
      image: '../../../../assets/img/static/cualitative.png',
      description: 'Selecciona si deseas crear una determinación cualitativo.',
      isCualitative: true,
      style: { width: '300px', backgroundColor: '#fff0ec' }
    },
    {
      title: 'Cuantitativo',
      image: '../../../../assets/img/static/cuantitative.png',
      description: 'Selecciona si deseas crear una determinación cuantitativo.',
      isCualitative: false,
      style: { width: '300px', backgroundColor: '#f7f7ff' }
    }
  ]; /* VARIABLES */

  //Formulario
  form: UntypedFormGroup;
  // limitsForm: UntypedFormGroup;
  showRangesControls = false
  private initialValues: { [key: string]: any }
  language = this.config.selectedLanguage;
  onEditionData: assayAnaliteInput;
  getErrorMessage = getErrorMessage;
  formControls: { [key: string]: AbstractControl; }
  selectItemEvent: Subject<void> = new Subject()
  showEcuationField = true
  currencyConfig = this.configService.currencyConfig
  ecuationFieldHasChanged = false
  public IndexToEdit: number
  validationBio = validationBio(this.config.appSettings.general.mode);

  //Subcripciones y datos externos
  subscriptions$ = new Subscription()
  assay: GetAssay_assay
  analites: GetAssay_assay_analites[]

  //Componente

  isLoading = false
  isSaving = false
  isCheckingValidators = false
  spinnerMessage = this.language.loading
  dataSavedOnDB = false
  documentEditForm: NgForm

  limitKinds = LimitKind
  limitKindsKeys = Object.keys(LimitKind)
  limitKindMap = LimitKindMap
  valueToInformKeys = Object.keys(valueToInform)
  valueToInformMap = valueToInformMap
  selectingType = false
  cualitative = false
  activeTabIndex: string = '0';
  analite_group_nameArray: string[] = []
  filteredGroups: string[] = [];
  isBio = this.config.isBio

  filterUnitsBy = new UntypedFormControl('')
  units: GetTechnicalConfigQuery_techConfigs[] = [];
  filteredUnits: GetTechnicalConfigQuery_techConfigs[] = [];

  units$: Observable<ApolloQueryResult<GetTechnicalConfigQuery>>

  filterCualResultOptionsBy = new UntypedFormControl('')
  filterCualResultOptions: GetTechnicalConfigQuery_techConfigs[] = []
  cualResultOptions: GetTechnicalConfigQuery_techConfigs[] = []

  methods: GetTechnicalConfigQuery_techConfigs[] = [];
  filteredMethods: GetTechnicalConfigQuery_techConfigs[] = [];

  filterAssaysBy = new UntypedFormControl('')
  filteredAssays: WritableSignal<GetAssays_assays[]> = signal([])
  assaysOptsSG = {
    name: 'assaysOptsSG',
    filteredValues: this.filteredAssays
  }

  cualResultOptions$: Observable<ApolloQueryResult<GetTechnicalConfigQuery>>

  analiteOptionsFiltered: Observable<GetAssayAnalite_assayAnalite[]>

  analiteSelected: GetAnalite_analite | GetAssayAnalite_assayAnalite_analite

  importReferenceOptions: { name: string, importReference: string }[] = []
  refInput = new FormControl("")

  /* END VARIABLES */

  // AGGRID //
  gridApi: GridApi
  getRowStyle = getRowStyle
  rowsSelected: GetAssayAnalite_assayAnalite_limits[] = []
  tableData: GetAssayAnalite_assayAnalite_limits[] = []

  columnDefs: ColDef[] = [
    { headerName: this.configService.selectedLanguage.limitKind, valueGetter: ({ data }) => this.limitKindMap.get(data?.limitKind) },
    { headerName: this.configService.selectedLanguage.value, field: 'theoricValue' },
    { headerName: this.configService.selectedLanguage.rangeMin, valueGetter: ({ data }) => data?.rangeMin || 'N/A' },
    { headerName: this.configService.selectedLanguage.rangeMax, valueGetter: ({ data }) => data?.rangeMax || 'N/A' },
    { headerName: this.configService.selectedLanguage.conclusion, field: 'conclusion' },
    {
      headerName: 'Resultado Cualitativo', field: 'cualResultOptionsConclusion', valueGetter: ({ data }) => {
        let options = []
        if (data.cualResultOptionsConclusion?.length && data.cualResultOptionsConclusion[0]?.hasOwnProperty('value')) {
          return data.cualResultOptionsConclusion?.map(option => option.value).join(' - ')
        }
        data.cualResultOptionsConclusion?.forEach(id => {
          let optionName = this.cualResultOptions.find(option => option.id === id)
          options.push(optionName?.value)
        });
        return options?.join(' - ') || 'N/A'
      }
    },
    {
      headerName: 'Ensayo a Agregar', field: 'limitAssays', valueGetter: ({ data }) => {
        let optionNames = []
        data.limitAssays?.forEach(id => {
          let option = this.opts.assaysOpts().find(option => option.id === id)
          optionNames.push(option.name)
        })
        return optionNames?.join(' - ') || 'N/A'
      }
    }
  ];

  /*Escucha cuando el usuario presiona la tecla enter y hace next al Subject que controla que se hayan cumplido las validaciones asincronas y luego emite el evento emit del formulario */
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      !this.disbledSaveButton() ?
        this.documentEditForm.ngSubmit.emit() :
        null
    }
  }

  rowSelection = singleRow;
  theme = _themeMaterial

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api
    this.autoSizeAll()
  }

  onSelectionChanged() {
    this.rowsSelected = this.gridApi.getSelectedRows();
  };

  deselectRows() {
    this.rowsSelected = []
    this.gridApi.deselectAll()
  }

  autoSizeAll() {
    if (!this.gridApi) return
    const allColumnIds = [];
    let columns = this.gridApi.getColumns()
    if (!columns || !columns.length) return null
    columns.forEach((column) => {
      allColumnIds.push(column.getColId());
    });
    this.gridApi.autoSizeColumns(allColumnIds);
  }


  @ViewChild('documentEditForm') set content(content: NgForm) {
    if (content) this.documentEditForm = content
  }

  /* LIFE CICLE HOOK`S */
  ngOnInit() {
    if (!this.data?.data) this.selectingType = true
    else this.selectType()
  }

  selectType(cualitative?: { isCualitative: false }) {
    if (cualitative?.isCualitative === false && this.data.payload.assay.groupConclusions) {
      this.ns.emitMessage('Deshabilitar agrupar conclusion para añadir cuantitativo')
      return
    }
    this.isLoading = true;
    this.selectingType = false;
    this.assay = this.data.payload.assay as GetAssay_assay
    this.analite_group_nameArray = Array.from(new Set(
      this.data.payload.analites?.map(analite => analite.analite_group_name)
        .filter(nameGroup => !!nameGroup)));
    if (cualitative) this.cualitative = cualitative.isCualitative
    this.analites = this.data.payload.analites
    this.importReferenceOptions = (this.analites as AssayAnalite[]).map(analite => ({ name: analite.analite?.name, importReference: analite.importReference, cualitative: analite.cualitative, id: analite.id }))
      .filter(_analite => {
        if (_analite.cualitative) return false
        if (_analite.id == this.data?.data) return false
        return true
      })

    if (this.data?.data) {
      this.aas.getOne({ id: this.data.data }).subscribe({
        next: ({ data: { assayAnalite } }) => {
          this.cualitative = assayAnalite.cualitative
          this.initDialog(assayAnalite)
          this.analiteSelected = assayAnalite.analite
        },
        error: err => {
          this.isLoading = false
          throw (err)
        }
      })
    } else this.initDialog()
  }

  initDialog(_data?: GetAssayAnalite_assayAnalite) {
    switch (this.aas.modeForm) {
      case estadoFormulario.registroNuevo:
        break;
      case estadoFormulario.registroEdicion:
        this.onEditionData = new assayAnaliteInput(_data);
        this.dataSavedOnDB = true;
        break;
      case estadoFormulario.registroMostrar:
        this.onEditionData = new assayAnaliteInput(_data);
        break;
    }

    // Create form.
    this.form = this.fb.group({
      analite: [],
      importReference: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9 #&-_áéíóúÁÉÍÓÚ]{1,99}$")]],
      alias: ['', [Validators.pattern("^[a-zA-Z0-9 #&-_áéíóúÁÉÍÓÚ]{1,99}$")]],
      calculated: [false],
      ecuation: [],
      skipNaN: [false],
      canDiscardValues: false,
      useAdjustedResultVariables: false,
      ecuationVariables: [[]],
      ecuationWithFragments: [],
      ecuationFragments: [],
      active: [true],
      accredited: [false],
      decimals: [+'', Validators.pattern("^[0-9]+$")],
      unit: [''],
      LC: [+'', Validators.pattern("^[0-9]+(\.[0-9]{1,2})?$")],
      LD: [+'', Validators.pattern("^[0-9]+(\.[0-9]{1,2})?$")],
      repetibility: [+'', Validators.pattern("^[0-9]+(\.[0-9]{1,2})?$")],
      uncertainty: [+'', Validators.pattern("^[0-9]+(\.[0-9]{1,2})?$")],
      cost: [+'', Validators.pattern("^[0-9]+(\.[0-9]{1,2})?$")],
      v_: [0],
      affectResults: [false],
      affectedResults: [false],
      limits: [[]],
      inform: true,
      valueToInform: valueToInform.ONLY_VALUE,
      assay: [this.as.idSelected.id],
      dependants: [],
      depends_on: [],
      humidity_kind: [],
      index: [],
      referenceValues: [[]],
      test_goal: [],
      input_type: [],
      sensitivity: [],
      specificity: [],
      interpretation: [],
      cualResultOptions: [[]],
      analite_group_name: [],
      methodId: [],
      record: [false],
      defaultResult: [],
      ecuation_validated: [],
      ecuation_validation_variables: [{}],
      ecuation_validation_expected_result: [],
      require_picture: [false],
    });

    if (this.isBio) {
      this.form.get('analite_group_name').valueChanges.pipe(
        startWith(''),
        map(value => this._filterGroups(value))
      ).subscribe(filtered => {
        this.filteredGroups = filtered;
      });
    }

    // this.limitsForm = this.fb.group({
    //   limitKind: ['', Validators.required],
    //   theoricValue: [null, [Validators.required, Validators.pattern("^$|[0-9]+(\.[0-9]{1,2})?$")]],
    //   rangeMin: [0],
    //   rangeMax: [0],
    //   conclusion: ['', Validators.required],
    //   cualResultOptionsConclusion: [[]],
    //   limitAssays: [[]],
    // })

    //Initialize form variables.
    this.formControls = this.form.controls;

    // Load information to form on Edit or Draft.
    if (this.onEditionData) {
      this.patchFormValues(this.onEditionData)
    }

    // Save initial form values.
    this.initialValues = _.cloneDeep(this.form.value)

    //Subscripcions
    this.formSubscriptions();

    this.form.updateValueAndValidity()

    //Set form´s validators.
    this.formControls.analite.setValidators([Validators.required]);
    this.formControls.importReference.setAsyncValidators([valueTakenValidatorGQL('importReference', this.initialValues, this.aas, 'assayAnalite', 'getOne', true)]);
    !this.cualitative ? this.formControls.unit.setValidators([Validators.required]) : null
    this.form.updateValueAndValidity({ emitEvent: false });

    this.units$ = this.cts.getAll(techConfModel.units).valueChanges.pipe(tap(({ data: { techConfigs } }) => {
      this.units = techConfigs;
      this.filteredUnits = this.units
    }), take(1))

    this.cualResultOptions$ = this.cts.getAll(TechConfigModels.cualResults).valueChanges.pipe(
      tap(({ data: { techConfigs } }) => {
        this.cualResultOptions = techConfigs;
        this.filterCualResultOptions = this.cualResultOptions
      }), take(1))

    let methods$ = this.cts.getAll(techConfModel.methods).valueChanges.pipe(tap(({ data: { techConfigs } }) => {
      this.methods = techConfigs;
      this.filteredMethods = this.methods
    }), take(1))

    let assays = this.opts.loadOptions([this.assaysOptsSG])

    forkJoin([this.units$, this.cualResultOptions$, methods$, ...assays]).subscribe({
      complete: () => { this.isLoading = false; this.filterUnitsBy.updateValueAndValidity() },
      error: err => { console.error(err); this.isLoading = false }
    })
  }

  _filterGroups(value: string): string[] {
    const filterValue = value ? value.toLowerCase() : '';
    return this.analite_group_nameArray.filter(group => group.toLowerCase().includes(filterValue));
  }

  ngOnDestroy() {
    this.subscriptions$.unsubscribe();
  }

  /* END LIFE CICLE HOOK´S */

  unitsFilteredValues($event: GetTechnicalConfigQuery_techConfigs[]) {
    this.filteredUnits = $event
  }

  /* SUBSCRIPTIONS */
  formSubscriptions() {

    this.subscriptions$ = this.form.valueChanges.subscribe((value: GetAssayAnalite_assayAnalite) => {
      this.dataSavedOnDB = compareObjects(value, this.initialValues, { ignoreEmptyValues: true });
    });

    let formEcuationSubs$ = this.form.get('ecuation').valueChanges.subscribe({
      next: value => {
        if (!this.initialValues) return;
        let hasChanged = this.initialValues?.ecuation !== value;
        if (this.ecuationFieldHasChanged !== hasChanged) {
          this.ecuationFieldHasChanged = hasChanged;

          if (!hasChanged && this.initialValues['ecuation_validated']) {
            this.form.controls.ecuation_validated.patchValue(true);
            this.isEquationValidated = true;
          }

          // Trigger validation again now that the state has changed
          this.form.controls.ecuation.updateValueAndValidity({ emitEvent: false });
        }
      }
    })

    let calculatedFormSubs$ = this.form.controls.calculated.valueChanges
      .pipe(startWith(this.form.controls.calculated.value))
      .subscribe({
        next: value => {
          if (value) {
            this.showEcuationField = true
            this.form.controls.ecuation.setValidators([Validators.required, this.equationValidatedValidator.bind(this)])
            this.form.controls.ecuation.updateValueAndValidity()
          } else {
            this.showEcuationField = false
            this.form.controls.ecuation.patchValue('');
            this.form.controls.ecuationVariables.patchValue([]);
            this.form.controls.ecuationWithFragments.patchValue('');
            this.form.controls.ecuationFragments.patchValue([]);
            this.form.controls.ecuation_validated.patchValue(false);
            this.form.controls.ecuation_validation_variables.patchValue({});
            this.form.controls.ecuation_validation_expected_result.patchValue(null);
            this.form.controls.ecuation.setValidators([])
            this.form.controls.ecuation.updateValueAndValidity()
          }
        }
      })

    let affectResults$ = this.form.controls.affectResults.valueChanges.subscribe({
      next: value => {
        if (value) {
          this.form.controls.affectedResults.patchValue(false)
          this.form.controls.affectedResults.updateValueAndValidity({ emitEvent: false })
        }
      }
    })

    let affectedResults$ = this.form.controls.affectedResults.valueChanges.subscribe({
      next: value => {
        if (value) {
          this.form.controls.affectResults.patchValue(false)
          this.form.controls.affectResults.updateValueAndValidity({ emitEvent: false })
        }
      }
    })

    let limits$ = this.form.controls.limits.valueChanges.subscribe({
      next: value => {
        this.tableData = value
      }
    })

    // let limitKind$ = this.limitsForm.controls.limitKind.valueChanges.subscribe({
    //   next: value => {
    //     if (this.showRangeFields(value)) {
    //       this.showRangesControls = true
    //       this.limitsForm.controls.rangeMin.setValidators([Validators.required, Validators.pattern("^[0-9]+(\.[0-9]{1,2})?$")])
    //       this.limitsForm.controls.rangeMax.setValidators([numberMustBeGreaterThan(this.limitsForm, 'rangeMin'), Validators.pattern("^[0-9]+(\.[0-9]{1,2})?$")])
    //       this.limitsForm.controls.conclusion.clearValidators()
    //       this.limitsForm.controls.rangeMin.updateValueAndValidity()
    //       this.limitsForm.controls.rangeMax.updateValueAndValidity()
    //       this.limitsForm.controls.conclusion.updateValueAndValidity()
    //       if(this.isBetweenRange(value)) {
    //         this.limitsForm.controls.theoricValue.clearValidators()
    //         this.limitsForm.controls.theoricValue.updateValueAndValidity()
    //       }
    //     } else if(value === this.limitKinds.INCLUDES) {
    //       this.limitsForm.controls.conclusion.setValidators([])
    //       this.limitsForm.controls.theoricValue.setValidators([])
    //       this.limitsForm.controls.cualResultOptionsConclusion.setValidators([Validators.required])
    //       this.limitsForm.controls.limitAssays.setValidators([Validators.required])
    //       this.limitsForm.controls.conclusion.updateValueAndValidity()
    //       this.limitsForm.controls.theoricValue.updateValueAndValidity()
    //       this.limitsForm.controls.cualResultOptionsConclusion.updateValueAndValidity()
    //       this.limitsForm.controls.limitAssays.updateValueAndValidity()
    //   }
    //     else {
    //       this.showRangesControls = false
    //       this.limitsForm.controls.rangeMin.clearValidators()
    //       this.limitsForm.controls.rangeMax.clearValidators()
    //       this.limitsForm.controls.conclusion.setValidators([Validators.required])
    //       this.limitsForm.controls.rangeMin.updateValueAndValidity()
    //       this.limitsForm.controls.rangeMax.updateValueAndValidity()
    //       this.limitsForm.controls.conclusion.updateValueAndValidity()

    //     }
    //   }
    // })

    this.subscriptions$.add(calculatedFormSubs$)
    this.subscriptions$.add(affectResults$)
    this.subscriptions$.add(affectedResults$)
    this.subscriptions$.add(limits$)
    // this.subscriptions$.add(limitKind$)
    this.subscriptions$.add(formEcuationSubs$)
  }

  /* END SUBSCRIPTIONS */

  /* FORM */
  patchFormValues(_value: GetAssayAnalite_assayAnalite | AssayAnaliteInput | assayAnaliteInput) {
    this.form.controls.analite.patchValue((_value as GetAssayAnalite_assayAnalite).analite.name || (_value as AssayAnaliteInput).analite);
    this.form.controls.importReference.patchValue(_value.importReference);
    this.form.controls.alias.patchValue((_value as AssayAnaliteInput).alias);
    this.form.controls.calculated.patchValue(_value.calculated);
    this.form.controls.ecuation.patchValue(_value.ecuationWithFragments || _value.ecuation);
    this.form.controls.skipNaN.patchValue(_value.skipNaN);
    this.form.controls.canDiscardValues.patchValue(_value.canDiscardValues);
    this.form.controls.useAdjustedResultVariables.patchValue(_value.useAdjustedResultVariables);
    this.form.controls.ecuationVariables.patchValue(_value.ecuationVariables);
    this.form.controls.ecuationFragments.patchValue(_value.ecuationFragments);
    this.form.controls.ecuationWithFragments.patchValue(_value.ecuationWithFragments);
    this.form.controls.active.patchValue(_value.active);
    this.form.controls.accredited.patchValue(_value.accredited);
    this.form.controls.decimals.patchValue(_value.decimals);
    this.form.controls.cost.patchValue(_value.cost)
    this.form.controls.unit.patchValue(((_value as GetAssayAnalite_assayAnalite).unit?.id || (_value as AssayAnaliteInput).unit));
    this.form.controls.v_.patchValue(_value.v_)
    this.form.controls.affectResults.patchValue(_value.affectResults)
    this.form.controls.affectedResults.patchValue(_value.affectedResults)
    this.form.controls.assay.patchValue(((_value as GetAssayAnalite_assayAnalite).assay.id || (_value as AssayAnaliteInput).assay))
    this.form.controls.dependants.patchValue(_value.dependants?.map(dependant => dependant.id))
    this.form.controls.depends_on.patchValue(_value.depends_on?.map(depends => depends.id))
    // this.form.controls.limits.patchValue(this.cleanLimitsValues((_value as GetAssayAnalite_assayAnalite).limits))
    this.form.controls.inform.patchValue(_value.inform)
    this.form.controls.valueToInform.patchValue(_value.valueToInform)
    // this.tableData = this.form.controls.limits.value
    this.form.controls.humidity_kind.patchValue(_value.humidity_kind)
    this.form.controls.index.patchValue(_value.index)
    this.form.controls.referenceValues.patchValue([..._value.referenceValues])
    this.form.controls.test_goal.patchValue(_value.test_goal)
    this.form.controls.input_type.patchValue(_value.input_type)
    this.form.controls.sensitivity.patchValue(_value.sensitivity)
    this.form.controls.specificity.patchValue(_value.specificity)
    this.form.controls.interpretation.patchValue(_value.interpretation)
    this.form.controls.cualResultOptions.patchValue([...(_value as GetAssayAnalite_assayAnalite).cualResultOptions.map(el => { return el.id })])
    this.form.controls.analite_group_name.patchValue(_value.analite_group_name)
    this.form.controls.methodId.patchValue((_value as any)?.method?.id || (_value as AssayAnaliteInput)?.methodId || null)
    this.form.controls.record.patchValue(_value.record)
    this.form.controls.defaultResult.patchValue(_value.defaultResult)
    this.form.controls.ecuation_validated.patchValue((_value as GetAssayAnalite_assayAnalite).ecuation_validated)
    this.form.controls.ecuation_validation_expected_result.patchValue((_value as GetAssayAnalite_assayAnalite).ecuation_validation_expected_result)
    let validationVariables = (_value as GetAssayAnalite_assayAnalite).ecuation_validation_variables;
    if (typeof validationVariables === 'string') {
      try {
        validationVariables = JSON.parse(validationVariables);
        // Handle double-stringified case if necessary, but safely
        if (typeof validationVariables === 'string') {
          validationVariables = JSON.parse(validationVariables);
        }
      } catch (e) {
        console.error('Error parsing ecuation_validation_variables', e);
        validationVariables = {};
      }
    }

    if (validationVariables && validationVariables.hasOwnProperty('expectedResult')) {
      this.form.controls.ecuation_validation_expected_result.patchValue(validationVariables.expectedResult);
      // We can optionally remove it from variables if we don't want it passed as a variable,
      // but EquationValidator filters variables anyway.
    }

    this.form.controls.ecuation_validation_variables.patchValue(validationVariables || {});
    this.form.controls.require_picture.patchValue((_value as GetAssayAnalite_assayAnalite).require_picture)

  }


  /* END FORM */

  validateNumericInput(controlName: string, event: any) {
    if (!event) return;
    let value = event.target.value;
    if (value.includes(',')) {
      value = value.replace(/,/g, '.');
      this.form.get(controlName).setValue(value);
      event.target.value = value;
    }
  }

  /* CRUD FUNCTIONS */
  save(formData: AssayAnaliteInput) {
    try {
      this.isSaving = true
      formData.analite = this.analiteSelected.id
      let data = new assayAnaliteInput({ ...formData, cualitative: this.cualitative })
      delete (data as any).limits
      if (formData.ecuation) data.processEcuation(this.ecuationFieldHasChanged, this.form.get('importReference').value)
      if (this.aas.modeForm === estadoFormulario.registroNuevo) {
        this.spinnerMessage = this.language.saving + '...';
        this.aas.save(data as AssayAnaliteInput)
          .subscribe({
            next: (value) => {
              this.aas.idSelected = undefined
              this.aas.getAll(this.as.idSelected.id).refetch()
              this.ns.emitMessage('Registro guardado')
              this.ref.close(true)
              this.subcriptionComplete()
            },
            error: err => this.localErrorHandler(err)
          }
          );
      } else {
        this.spinnerMessage = this.language.updating + '...';
        this.aas.update(this.onEditionData.id, data as AssayAnaliteInput)
          .subscribe({
            next: () => {
              this.aas.idSelected = undefined
              this.aas.getAll(this.as.idSelected.id).refetch()
              this.ns.emitMessage('Registro actualizado')
              this.ref.close(true)
              this.subcriptionComplete();
            },
            error: err => this.localErrorHandler(err)
          }
          )
      }
    } catch (err) {
      this.isSaving = false
      throw err
    }
  };

  /* END CRUD FUNCTIONS */

  /* DIALOG */
  closeDialog() {
    this.aas.clearDraft();
    this.aas.modeForm = estadoFormulario.registroNuevo;
    this.ref.close();
  }

  /* END DIALOG */


  /* PERMISSIONS AND CONTROL VALUES */

  disbledSaveButton() {
    return (!this.form.valid ||
      this.aas.modeForm == estadoFormulario.registroMostrar ||
      this.dataSavedOnDB == true)
  }

  disbledCloneButton() {
    return this.isSaving
  }


  // Select functions
  resetSelectOptions() {
    this.filterUnitsBy.patchValue('')
  }

  showEcuationFragmentsButton() {
    return this.configService.appSettings.frontend?.forms?.assay_analite?.ecuation_fragments?.active && this.form.controls.calculated.value == true
  }
  showCloneButton() {
    return this.configService.appSettings.frontend?.forms?.assay_analite?.clone?.active
  }

  /*OTHER FUNCTIONS */

  selectingAnaliteFromTable: boolean = false;

  openAnaliteOptionsTableDialog() {
    this.ass.modeForm = estadoFormulario.seleccionRegistro;
    this.selectingAnaliteFromTable = true;
  }

  onAnaliteSelected(value: GetAnalite_analite) {
    if (value?.id && !value.active) {
      this.ns.emitMessage('La determinación seleccionada no se encuentra activa', true, 'error');
      return;
    }
    if (value?.id) {
      this.analiteSelected = value;
      let importReference = `${this.assay.abbreviation}_${value.abbreviation}`;
      this.form.controls.importReference.patchValue(importReference);
      this.form.controls.analite.patchValue(value.name);
    }
    this.selectingAnaliteFromTable = false;
    this.ass.modeForm = estadoFormulario.registroNuevo;
  }

  cancelAnaliteSelection() {
    this.selectingAnaliteFromTable = false;
    this.ass.modeForm = estadoFormulario.registroNuevo;
  }

  localErrorHandler(err) {
    this.isSaving = false;
    this.spinnerMessage = 'Cargando...';
    let controlsKeys = Object.keys(this.form.controls)
    controlsKeys.map(control => this.form.controls[control].updateValueAndValidity())
    throw err
  };

  subcriptionComplete() {
    this.spinnerMessage = 'Cargando...'

    this.aas.modeForm == estadoFormulario.registroEdicion
    this.dataSavedOnDB = true
    this.isSaving = false;
  };

  showHumidityKind() {
    return this.form.controls.affectResults.value && !this.cualitative && this.assay.multi_humidity_adjustment
  }

  methodsFilteredValues($event: GetTechnicalConfigQuery_techConfigs[]) {
    this.filteredMethods = $event
  }

  /* Ecuation context menu */

  contextMenuPosition = { x: '0px', y: '0px' }

  contextMenu: OverlayPanel
  @ViewChild('op') set trigger(trigger: OverlayPanel) {
    if (trigger) this.contextMenu = trigger
  }

  ecuationInput: ElementRef
  @ViewChild("ecuationInput") set input(input: ElementRef) {
    if (input) this.ecuationInput = input
  }

  getCursor(input: ElementRef): [number, number] {
    let start = input.nativeElement.selectionStart | 0
    let end = input.nativeElement.selectionEnd | 0
    return [start, end]
  }

  cursor: [number, number] = [0, 0]
  ecuationInputContextMenu(event: MouseEvent) {
    event.preventDefault()
    this.cursor = this.getCursor(this.ecuationInput)
    if (this.contextMenu) this.contextMenu.toggle(event);
  }

  insertVariable(input: ElementRef, variable: string, cursor: [number, number], isFragment = false) {
    let currentValue = input.nativeElement.value
    let prefix = isFragment ? 'F' : 'I'
    let patchedValue = currentValue.substr(0, cursor[0]) + `{${prefix}_${variable}}` + currentValue.substr(cursor[1])
    this.form.controls.ecuation.patchValue(patchedValue)
  }

  isEquationValidated = false;

  onEquationValidationChange(validationData: any) {
    const isValid = validationData.isValid;

    // If the component emits false (e.g. on init), but we have a trusted valid state and no changes, ignore the reset.
    if (!isValid && this.form.controls.ecuation_validated.value === true && !this.ecuationFieldHasChanged) {
      this.isEquationValidated = true;
      return;
    }
    this.isEquationValidated = isValid;
    this.form.controls.ecuation.updateValueAndValidity();
    this.form.controls.ecuation_validated.patchValue(isValid);

    if (isValid) {
      const variablesToSave = {
        ...validationData.variables,
        expectedResult: validationData.expectedResult
      };
      this.form.controls.ecuation_validation_variables.patchValue(variablesToSave);
      this.form.controls.ecuation_validation_expected_result.patchValue(validationData.expectedResult);
    } else {
      // Optional: Clear these if validation fails, or keep last known good?
      // Usually better to clear if invalid to avoid mismatch.
      this.form.controls.ecuation_validation_variables.patchValue({});
      this.form.controls.ecuation_validation_expected_result.patchValue(null);
    }
  }

  equationValidatedValidator(control: AbstractControl) {
    if (!this.showEcuationField) {
      return null;
    }

    // If the equation is already validated (from DB/initial load) and hasn't changed, it's valid.
    if (this.form.controls.ecuation_validated.value === true && !this.ecuationFieldHasChanged) {
      return null;
    }

    // If in edit mode, only validate if the equation has changed (Legacy check, kept for safety but covered above if ecuation_validated is set correctly)
    if (this.aas.modeForm === estadoFormulario.registroEdicion) {
      if (!this.ecuationFieldHasChanged) {
        return null;
      }
    }

    if (!this.isEquationValidated) {
      return { equationNotValidated: true };
    }
    return null;
  }

  /*Ecuation Fragments */

  openEcuationFragments() {
    let dialogRef = this.dialog.open(AssayAnaliteEcuationFragmentsComponent, {
      width: '700px',
      data: {
        importReferenceOptions: this.importReferenceOptions,
        fragments: this.form.get('ecuationFragments').value
      }
    });

    dialogRef.afterClosed().subscribe({
      next: value => {
        if (value) this.form.get('ecuationFragments').patchValue(value)
      }
    })
  }
  addReferenceValue(value: string, IndexToEditIndex: number): void {
    let currentReference = this.form.controls.referenceValues.value

    if (IndexToEditIndex || IndexToEditIndex == 0) {
      currentReference[IndexToEditIndex] = value
      this.IndexToEdit = null;
    } else {
      currentReference.push(value)
    }
    this.form.controls.referenceValues.patchValue([...currentReference])
    this.refInput.patchValue('')
  }

  editReference(value: string, i: number): void {
    this.IndexToEdit = i;
    this.refInput.patchValue(value)
  }

  remove(value: string, index: number): void {
    let currentReference = this.form.controls.referenceValues.value
    let newReferences = currentReference.filter((value, i) => i !== index)

    this.form.controls.referenceValues.patchValue([...newReferences])
  }

  cancelEditMode(): void {
    this.IndexToEdit = null
    this.refInput.patchValue('')
  }

  disableReferenceValue(referenceValue: string): boolean {
    if (referenceValue != '') return false
    else return true
  }

  cualResultOptionsFilteredValues($event: GetTechnicalConfigQuery_techConfigs[]) {
    this.filterCualResultOptions = $event
  }

  buttonConfig(ctrl, nameComponent, model, result_type) {
    this.cts.modeForm = estadoFormulario.registroNuevo;
    let data = undefined;
    let nameObj = {};
    let headerTitle = 'Configuración';

    switch (nameComponent) {
      case "FormTechConfig":
        const link = this.cts.filterLinks(model);
        nameObj = { techConfigLink: link };
        headerTitle = link?.form?.title?.new || 'Configuración Técnica';
        break;
      case "FormAdminConfigComponent":
        const adminLink = this.acs.filterLinks(model);
        nameObj = { adminConfigLink: adminLink };
        headerTitle = adminLink?.form?.title?.new || 'Configuración';
        break;
    }

    const component = this.pipeNameComponent.transform(nameComponent);
    if (!component) return;

    let dialogRef = this.dialogService.open(component, {
      header: headerTitle,
      width: '450px',
      position: 'right',
      modal: true,
      styleClass: 'sidebar-dialog',
      data: {
        data,
        ...nameObj || null
      }
    });

    dialogRef.onClose.subscribe({
      next: async (data) => {
        let resp = await data;
        if (!resp) return;

        switch (ctrl) {
          case 'unit':
            this.units = resp?.data?.[result_type];
            this.filteredUnits = resp?.data?.[result_type];
            break;
          case 'methodId':
            this.methods = resp?.data?.[result_type];
            this.filteredMethods = resp?.data?.[result_type];
            break;
        }
        this.form.get(ctrl)?.updateValueAndValidity({ emitEvent: false })
      }
    })

  }

  openTableCopyAssayAnalitesConfig() {
    this.TDS.TableCopyAssayAnalitesConfig.grid.flex.selection_kind = 'ASSAYS'
    const ref = this.dialogService.open(TableDinamicComponent, {
      header: 'Copiar Configuración',
      width: '80%',
      modal: true,
      data: { tableConfig: this.TDS.TableCopyAssayAnalitesConfig }
    })

    ref.onClose.subscribe({
      next: (value) => {
        // if(value)
        //this.tableData$.refetch()
      }
    })
  }

  filterKeys(_limitKindKeys) {
    if (this.cualitative) _limitKindKeys = _limitKindKeys.filter(el => el == 'INCLUDES')
    else _limitKindKeys = _limitKindKeys.filter(el => el !== 'INCLUDES')
    return _limitKindKeys
  }

  getCualResultOption(id: string) {
    let ob = this.cualResultOptions.find(el => el.id == id)
    if (!ob) return
    return ob.code + ' - ' + ob.value
  }

  get equationInput() {
    const formData = this.form.value
    let data = new assayAnaliteInput({ ...formData, cualitative: this.cualitative })
    if (formData.ecuation) data.processEcuation(this.ecuationFieldHasChanged, this.form.get('importReference').value, false)
    return data.ecuation
  }

  showFormControl = (form: string, control: string) => {
      let controlConfig: IAppSettingsFrontendFormControlConfig = this.configService.appSettings.frontend.forms[form][control]
      if (!controlConfig?.active) return false
      return true
  }
}
